import React, { useCallback } from "react";
import { connect } from "react-redux";

import Form from "antd/es/form";
import cn from "classnames";

import { EmailBody } from "@mapmycustomers/ui";

import { loadImageToEmailBody } from "@app/store/email/actions";

import styles from "./EmailPreferences.module.scss";

interface Props {
  onLoadImageToEmailBody: typeof loadImageToEmailBody;
  visible: boolean;
}

const SignatureText: React.FC<Props> = ({ onLoadImageToEmailBody, visible }) => {
  const handleLoadImage = useCallback(
    (file: Blob, callback: (url: string) => void) => {
      onLoadImageToEmailBody({
        callback,
        file,
      });
    },
    [onLoadImageToEmailBody]
  );

  return (
    <div className={cn({ [styles.hidden]: !visible })}>
      <Form.Item name="signatureText">
        <EmailBody
          className={styles.signatureTextEditor}
          containerClassName={styles.signatureText}
          onLoadFile={handleLoadImage}
        />
      </Form.Item>
    </div>
  );
};

const mapDispatchToProps = {
  onLoadImageToEmailBody: loadImageToEmailBody,
};

export default connect(null, mapDispatchToProps)(SignatureText);
